// removed by extract-text-webpack-plugin
module.exports = {"Card":"A4v4A0kGKLzTMQTFZfUoc","Header":"_2gJj_5rwVACcKl6o2Ppbqg","Title":"_1lW2HmMgObgdNhab8LWR0z","RecordId":"_2fwNpWHhUEd4IzRYsyQnfY","Body":"_1YqomynzIyKQApQbewGt6i","Row":"_1whHEVNr6EQK_VgTtSRsMf","Label":"_1yqEUzuTAtkviH2QX5i1J-","Value":"_2C5wXnSeRp4bkYzT2dkFGc","ValueMono":"L9KLloPS9aHuL4ka7yDKZ","StatusBlocked":"_2T-IHitrQQ6gfFnOwbFZXE","StatusOk":"_2l-havazBiCcfvL_SxAzLh","MetaSection":"TdmvZICpQadQmLXsW6LG6","Meta":"_11vrgtdNqI2vNrCGCi9uHP","Actions":"_2vjAF7nVaFA3iEksdFVUbJ","UnblockBtn":"_12NPxlK97l6ubz07X_-RO4","DeleteBtn":"_3Ff47yLabBU0zGfdQE2O94"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/ComponentsOfAdministrator/AntiFraudDetails/styles.module.css
// module id = 531
// module chunks = 0